import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrums from '../../components/company_panel/common/breadcrumbs';
import Swal from 'sweetalert2';
import { Button, Modal } from 'react-bootstrap';
import { EmailSend, GetPurchaseOrderDetail, confirmPurchaseOrderInventories } from '../../services/company_panel/purchaseOrderService';
import { capitalizeFirstLetter, companyDetail, formateDate, formatToTwoDecimals, getBrandId, getOutletId, showPrice, TrimText } from '../../helpers/commonFunctions';
import notFound from '../../assets/company/img/no-record-found.png';
import Loader from '../../components/company_panel/common/loader';
import { FILE_SLUGS, UPLOAD_DIRS } from '../../utils/Constants';
import { GetGCPSignedUploadUrl } from '../../services/commonService';

const ORDER_STATUS_PILL = {
    pending: 'warning',
    received: 'success',
    cancelled: 'danger',
};

const OrderView = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [showDefault, setShowDefault] = useState({});
    const breadcrumbs = [{ title: "Purchase order", url: `/company/store_manager/purchase_order/list/${params?.pgno || 1}` }, { title: "View", url: "" }];
    const [statsUpdate, setStatusUpdate] = useState("false");
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState({});
    // let totalPrice = 0;
    const [totalPrice, setTotalPrice] = useState(0);
    // const [finalPrice, setFinalPrice] = useState(0);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [currentOutlet] = useState(getOutletId());
    const [isOutletChanged, setIsOutletChanged] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [previewFileType, setPreviewFileType] = useState(null);
    const [pdfFileName, setPdfFileName] = useState('');
    const [invoiceError, setInvoiceError] = useState(false);
    const [emailSending, setEmailSending] = useState(false);
    const [loading, setLoading] = useState(true);


    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        });
        if (currentOutlet != getOutletId()) {
            navigate(`/company/store_manager/purchase_order/list/${params?.pgno || 1}`);
        }
    });

    useEffect(() => {
        GetPurchaseOrderDetail({ id: params.id }).then(data => {
            const responseData = data && data.data && data.data.response ? data.data.response : [];
            setShowDefault(responseData);
            const initialQuantities = responseData.purchase_orders_inventories.reduce((acc, item) => {
                acc[item.inventory_id] = item.ordered_quantity;
                return acc;
            }, {});
            setQuantities(initialQuantities);
            setLoading(false);
        }).catch(error => {
            console.log("error=====>", error);
            setLoading(false);
        });
    }, [statsUpdate]);

    useEffect(() => {
        if (showDefault?.purchase_orders_inventories) {
            const newTotalPrice = showDefault.purchase_orders_inventories.reduce((acc, item) => {
                const quantity = showDefault.order_status === 'received' ? item?.recieved_quantity : quantities[item.inventory_id];
                return acc + (quantity * item?.price);
            }, 0);
            setTotalPrice(newTotalPrice);
        }
    }, [showDefault]);

    const handleQuantityChange = (inventory_id, newQuantity) => {
        setQuantities(prevQuantities => ({
            ...prevQuantities,
            [inventory_id]: newQuantity
        }));
    };

    // const handleConfirm = () => {
    //     const updatedItems = showDefault.purchase_orders_inventories.map(item => ({
    //         inventory_id: item.inventory_id,
    //         item_name: item.inventory.item_name,
    //         quantity: Number(quantities[item.inventory_id]),
    //         ordered_quantity: item.ordered_quantity,
    //         price: item.price
    //     }));
    //     const newTotalPrice = updatedItems.reduce((acc, item) => {
    //         const quantity = item?.quantity ? item?.quantity : 0
    //         return acc + (quantity * item?.price);
    //     }, 0);
    //     setTotalPrice(newTotalPrice);
    //     confirmPurchaseOrderInventories({
    //         purchase_order_id: params.id,
    //         final_price: newTotalPrice ? newTotalPrice : totalPrice,
    //         inventories: updatedItems,
    //         company_id: getCompany().company_id,
    //         outlet_id: showDefault.outlet_id
    //     }).then(response => {

    //         setShowModal(false);
    //         Swal.fire({
    //             customClass: 'swal-wide',
    //             position: 'absolute',
    //             icon: 'success',
    //             title: 'Order marked as received',
    //             showConfirmButton: false,
    //             timer: 2000,
    //             toast: true,
    //             position: 'top-right',
    //         });
    //         setStatusUpdate(!statsUpdate);
    //     }).catch(error => {
    //         console.log("updateError", error);
    //     });
    // };

    const handleConfirm = async () => {
        const invoiceNumber = document.getElementById("invoice_number").value;
        const logoInput = document.getElementById("logo");
        const logoFile = logoInput.files[0];

        let isRecievedQuantityValid = true;

        // id is the purchase order's inventory row, so the API updates that record
        const receivedItems = showDefault.purchase_orders_inventories.map(item => {
            const received_quantity = Number(quantities[item.inventory_id]);
            if (!(received_quantity > 0)) {
                isRecievedQuantityValid = false;
            }
            return { id: item.id, received_quantity, price: item.price };
        });

        if(!isRecievedQuantityValid){
            Swal.fire({
                customClass: 'swal-wide',
                position: 'absolute',
                icon: 'error',
                title: 'Please input valid received quantities',
                showConfirmButton: false,
                timer: 2000,
                toast: true,
                position: 'top-right',
            });
            return;
        }

        const newTotalPrice = receivedItems.reduce((acc, item) => {
            const quantity = item?.received_quantity ? item?.received_quantity : 0
            return acc + (quantity * item?.price);
        }, 0);
        setTotalPrice(newTotalPrice);
        try {
            const company_register_id = companyDetail().company_id;

            const formData = new FormData();
            formData.append("purchase_order_id", params.id);
            formData.append("final_price", newTotalPrice ? newTotalPrice : totalPrice);
            formData.append("inventories", JSON.stringify(receivedItems.map(({ id, received_quantity }) => ({ id, received_quantity }))));
            formData.append("invoice_number", invoiceNumber);

            let filenameUploaded;
            if (logoFile instanceof File) {
                try {
                    const signedRes = await GetGCPSignedUploadUrl({
                        original_name: logoFile.name,
                        file_prefix: FILE_SLUGS.PURCHASE_ORDER_INVOICE_LOGO,
                        mime_type: logoFile.type,
                        folder: `company-id-${company_register_id}/brand-id-${getBrandId()}/${UPLOAD_DIRS.PURCHASE_ORDER_INVOICE_LOGO}`,
                    });
                    const { signedUrl, filename } = signedRes?.data?.response;
                    await fetch(signedUrl, { method: 'PUT', headers: { 'Content-Type': logoFile.type }, body: logoFile });
                    filenameUploaded = filename;
                } catch (uploadError) {
                    console.log("Media upload error ====> ", uploadError);
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: 'Something went wrong. Please try again.',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true,
                        position: 'top-right',
                    });
                }
            }
            if (filenameUploaded) {
                formData.append('invoice_logo', filenameUploaded);
            }

            const response = await confirmPurchaseOrderInventories(formData);
            setShowModal(false);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: 'Order marked as received',
                showConfirmButton: false,
                timer: 2000,
                toast: true,
                position: 'top-right',
            });
            setStatusUpdate(!statsUpdate);
        } catch (error) {
            console.log("updateError", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: 'Something went wrong. Please try again.',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
        }
    };



    function sendEmail(data) {
        const formData = new FormData();
        formData.append("supplier_id", data?.supplier_id);
        formData.append("outlet_id", getOutletId());
        formData.append("order_id", data?.id);
        if (showDefault?.purchase_orders_inventories && showDefault?.purchase_orders_inventories.length) {
            formData.append("tableData", JSON.stringify(showDefault?.purchase_orders_inventories));
        }
        setEmailSending(true);
        EmailSend(formData).then(data => {
            if (data.status === 200) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'success',
                    title: 'Email sent successfully',
                    showConfirmButton: false,
                    timer: 2000,
                    toast: true,
                    position: 'top-right',
                });
            }
        }).catch(error => {
            console.log("sendEmailError", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: 'Something went wrong. Please try again.',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
        }).finally(() => {
            setEmailSending(false);
        });
    }

    const [isFormValid, setIsFormValid] = useState(false);

    // const validateForm = () => {
    //     const invoiceNumber = document.getElementById('invoice_number').value;
    //     const isInvoiceNumberValid = /^[1-9][0-9]*$/.test(invoiceNumber) && invoiceNumber.length <= 15;

    //     const logoFile = document.getElementById('logo').files[0];
    //     const isLogoUploaded = logoFile && logoFile.size > 0;

    //     let isFileValid = true;
    //     if (logoFile) {
    //         const fileSizeInMB = logoFile.size / (1024 * 1024);
    //         if (isImage(logoFile.name) && fileSizeInMB > 10) {
    //             isFileValid = false;
    //         }
    //         if (isPDF(logoFile.name) && fileSizeInMB > 10) {
    //             isFileValid = false;
    //         }
    //     }

    //     setIsFormValid(isInvoiceNumberValid && isLogoUploaded && isFileValid);
    // };

    const validateForm = () => {
        const invoiceNumber = document.getElementById('invoice_number').value;
        const isInvoiceNumberValid = /^[1-9][0-9]*$/.test(invoiceNumber) && invoiceNumber.length <= 15;

        const logoFileInput = document.getElementById('logo');
        const logoFile = logoFileInput.files[0];
        const isLogoUploaded = logoFile && logoFile.size > 0;

        let isFileValid = true;
        if (isInvoiceNumberValid) {
            setInvoiceError(false)
        } else {
            setInvoiceError(true);
        }
        if (logoFile) {
            const fileSizeInMB = logoFile.size / (1024 * 1024);
            if ((isImage(logoFile.name) || isPDF(logoFile.name)) && fileSizeInMB > 10) {
                isFileValid = false;
                Swal.fire({
                    icon: 'error',
                    title: 'File size exceeds limit',
                    text: 'Image or PDF file size should not exceed 10 MB.',
                });
            }
        }
        setIsFormValid(isInvoiceNumberValid && isLogoUploaded && isFileValid);
    };


    const fillOrderedQuantities = () => {
        setQuantities(items.reduce((acc, item) => {
            acc[item.inventory_id] = item.ordered_quantity;
            return acc;
        }, {}));
    };

    const clearInvoiceFile = () => {
        const logoInput = document.getElementById('logo');
        if (logoInput) {
            logoInput.value = '';
        }
        setPreviewImage(null);
        setPreviewFileType(null);
        setPdfFileName('');
        setIsFormValid(false);
    };

    const resetForm = () => {
        setIsFormValid(false);
        setPreviewImage(null);
        setPreviewFileType(null);
        setPdfFileName('');
        setInvoiceError(false);
    };

    const handleCloseModal = () => {
        resetForm();
        setShowModal(false);
    };

    const getFileSize = (url) => {
        const file = new File([url], url);
        return file.size / (1024 * 1024); // file size in MB
    };

    const isImage = (url) => /\.(jpeg|jpg|gif|png|webp)$/i.test(url);
    const isPDF = (url) => /\.pdf$/i.test(url);

    const renderFileContent = (url) => {
        const fileSize = getFileSize(url);

        if (isImage(url) && fileSize > 10) {
            return <div className="text-danger">Image size exceeds 10 MB</div>;
        }

        if (isPDF(url) && fileSize > 10) {
            return <div className="text-danger">PDF size exceeds 10 MB</div>;
        }

        if (!isImage(url) && !isPDF(url)) {
            return "N/A";
        }

        // a chip keeps the panel tidy and avoids a broken <img> when the file is gone
        return (
            <a href={url} target="_blank" rel="noreferrer" className="po-file-chip" title={url.split('/').pop()}>
                <i className={isPDF(url) ? "ti ti-file-text" : "ti ti-photo"}></i>
                View invoice
            </a>
        );
    };

    const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png', 'image/webp'];

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['jpeg', 'jpg', 'gif', 'png', 'webp'];

            if (allowedImageTypes.includes(file.type) && allowedExtensions.includes(fileExtension)) {
                setPreviewImage(URL.createObjectURL(file));
                setPreviewFileType('image');
                setPdfFileName('');
            } else if (file.type === 'application/pdf') {
                setPreviewImage(null);
                setPreviewFileType('pdf');
                setPdfFileName(file.name);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Image Type',
                    text: 'Please upload a valid image file (JPEG, JPG, GIF, PNG, WEBP).',
                });
                e.target.value = '';  // Clear the invalid file
                return;
            }
        }
        validateForm();
    };

    const orderStatus = showDefault?.order_status || '';
    const isPending = orderStatus === 'pending';
    const isReceived = orderStatus === 'received';
    const items = showDefault?.purchase_orders_inventories || [];
    const receivedTotal = items.reduce((acc, item) => acc + (Number(quantities[item.inventory_id] || 0) * Number(item?.price)), 0);
    const orderValue = isReceived && showDefault?.final_price ? Number(showDefault.final_price) : Number(totalPrice);
    const supplierAddress = [showDefault?.supplier?.street_address, showDefault?.supplier?.city, showDefault?.supplier?.zip_code].filter(Boolean).join(', ');

    return (
        <>
            <div className="page-header d-flex align-items-center justify-content-between">
                <div className="page-header-left">
                    <Breadcrums data={breadcrumbs} />
                    <h4>Purchase order</h4>
                </div>
                <div className="d-flex gap-2">
                    <button className="btn ripple btn-secondary" type='button' onClick={() => navigate(-1)}>
                        Back
                    </button>
                    {isPending ?
                        <Button variant="primary" onClick={() => setShowModal(true)}>
                            Mark as Received
                        </Button>
                        : null}
                </div>
            </div>

            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            {loading ? <Loader /> : (
                                <>
                                    <div className="po-hero">
                                        <div>
                                            <div className="po-hero-title">
                                                <span>Purchase Order #{showDefault?.id}</span>
                                                {orderStatus ?
                                                    <span className={`status-pill ${ORDER_STATUS_PILL[orderStatus] || 'muted'}`}>{capitalizeFirstLetter(orderStatus)}</span>
                                                    : null}
                                            </div>
                                            <div className="po-hero-sub">
                                                <span><i className="ti ti-building-store"></i>{capitalizeFirstLetter(showDefault?.outlet?.outlet_name) || "N/A"}{showDefault?.outlet?.short_code ? ` (${showDefault?.outlet?.short_code})` : ''}</span>
                                                <span><i className="ti ti-calendar"></i>Created {showDefault?.created_at ? formateDate(showDefault?.created_at) : "N/A"}</span>
                                                <span><i className="ti ti-truck-delivery"></i>Delivery {showDefault?.delivery_date ? formateDate(showDefault?.delivery_date) : "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="po-hero-amount-box">
                                            <span className="po-hero-amount-label">{isReceived ? 'Final Price' : 'Estimated Value'}</span>
                                            <span className="po-hero-amount">{showPrice(orderValue)} <small>SAR</small></span>
                                        </div>
                                    </div>

                                    <div className="po-grid">
                                        <section className="po-panel">
                                            <div className="po-panel-head">
                                                <h6 className="po-panel-title mb-0"><i className="ti ti-user"></i>Supplier</h6>
                                                <button className="btn btn-outline-primary btn-sm po-panel-action" type="button" onClick={() => sendEmail(showDefault)} disabled={!showDefault?.id || emailSending}>
                                                    <i className="ti ti-mail"></i>
                                                    {emailSending ? 'Sending...' : 'Send Email'}
                                                </button>
                                            </div>
                                            <div className="po-supplier-name">{capitalizeFirstLetter(showDefault?.supplier?.name) || "N/A"}</div>
                                            <div className="po-row">
                                                <span>Email</span>
                                                <span>{showDefault?.supplier?.email ? <a href={`mailto:${showDefault?.supplier?.email}`}>{showDefault?.supplier?.email}</a> : "N/A"}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>Phone</span>
                                                <span>{showDefault?.supplier?.phone_number ? `+${showDefault?.supplier?.country_code || ''} ${showDefault?.supplier?.phone_number}` : "N/A"}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>Address</span>
                                                <span>{supplierAddress ? capitalizeFirstLetter(supplierAddress) : "N/A"}</span>
                                            </div>
                                        </section>

                                        <section className="po-panel">
                                            <div className="po-panel-head">
                                                <h6 className="po-panel-title mb-0"><i className="ti ti-clipboard-list"></i>Order</h6>
                                            </div>
                                            <div className="po-row">
                                                <span>Outlet</span>
                                                <span>{capitalizeFirstLetter(showDefault?.outlet?.outlet_name) || "N/A"}{showDefault?.outlet?.short_code ? ` (${showDefault?.outlet?.short_code})` : ''}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>Delivery Date</span>
                                                <span>{showDefault?.delivery_date ? formateDate(showDefault?.delivery_date) : "N/A"}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>Created On</span>
                                                <span>{showDefault?.created_at ? formateDate(showDefault?.created_at) : "N/A"}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>ERP Reference ID</span>
                                                <span>{showDefault?.erp_reference_id ? showDefault?.erp_reference_id : "N/A"}</span>
                                            </div>
                                        </section>

                                        <section className="po-panel">
                                            <div className="po-panel-head">
                                                <h6 className="po-panel-title mb-0"><i className="ti ti-file-invoice"></i>Invoice</h6>
                                            </div>
                                            <div className="po-row">
                                                <span>Invoice Number</span>
                                                <span>{showDefault?.invoice_number ? showDefault?.invoice_number : "N/A"}</span>
                                            </div>
                                            <div className="po-row">
                                                <span>Attachment</span>
                                                <span>{showDefault?.invoice_logo ? renderFileContent(showDefault?.invoice_logo) : "N/A"}</span>
                                            </div>
                                            {!isReceived ?
                                                <p className="po-panel-note">Invoice details are captured when the order is marked as received.</p>
                                                : null}
                                        </section>
                                    </div>

                                    <div className="po-items">
                                        <div className="po-items-head">
                                            <h6 className="po-panel-title mb-0"><i className="ti ti-package"></i>Items</h6>
                                            {items.length ? <span className="po-items-count">{items.length} {items.length > 1 ? 'items' : 'item'}</span> : null}
                                        </div>
                                        {items.length ? (
                                            <>
                                                <div className="po-table-wrap">
                                                    <table className="table table-custom po-table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Item Name</th>
                                                                <th>Unit of Measure</th>
                                                                <th className="text-end">Ordered Quantity</th>
                                                                <th className="text-end">Received Quantity</th>
                                                                <th className="text-end">Unit Price</th>
                                                                <th className="text-end">Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((item, index) => {
                                                                const lineQuantity = isReceived ? item?.recieved_quantity : item?.ordered_quantity;
                                                                const isShort = isReceived && Number(item?.recieved_quantity) < Number(item?.ordered_quantity);
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="po-item-name">{capitalizeFirstLetter(item?.inventory?.item_name) || "N/A"}</td>
                                                                        <td>{item?.inventory?.uom?.uom ? `${capitalizeFirstLetter(item?.inventory?.uom?.uom)} (${item?.inventory?.uom?.uom_code})` : "N/A"}</td>
                                                                        <td className="text-end">{formatToTwoDecimals(item?.ordered_quantity)}</td>
                                                                        <td className={`text-end ${isShort ? 'po-qty-short' : ''}`}>
                                                                            {item?.recieved_quantity ? formatToTwoDecimals(item?.recieved_quantity) : "-"}
                                                                            {isShort ? <i className="ti ti-alert-triangle ms-1" title="Received less than ordered"></i> : null}
                                                                        </td>
                                                                        <td className="text-end">{showPrice(item?.price)} SAR</td>
                                                                        <td className="text-end fw-semibold">{formatToTwoDecimals(Number(lineQuantity) * Number(item?.price))} SAR</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr className="po-total-row">
                                                                <td colSpan="5" className="text-end">{isReceived ? 'Final Price' : 'Estimated Value'}</td>
                                                                <td className="text-end">{showPrice(orderValue)} SAR</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </>
                                        ) : (
                                            <div className='text-center m-3'>
                                                <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                <p className='mt-3'>No record found</p>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showModal} onHide={handleCloseModal} backdrop={'static'} size="lg" centered className="po-receive-modal">
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>Mark as Received</Modal.Title>
                        <p className="po-modal-sub">Confirm what actually arrived for purchase order #{showDefault?.id}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="po-modal-section-head">
                        <h6 className="po-panel-title mb-0">Received quantities</h6>
                        <button type="button" className="btn btn-link btn-sm po-fill-link" onClick={fillOrderedQuantities}>
                            Fill ordered quantities
                        </button>
                    </div>
                    <div className="po-table-wrap">
                        <table className="table table-custom po-table mb-0">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Unit of Measure</th>
                                    <th className="text-end">Unit Price</th>
                                    <th className="text-end">Ordered</th>
                                    <th className="text-end po-receive-col">Received</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => {
                                    const entered = quantities[item.inventory_id];
                                    const isInvalid = !(Number(entered) > 0);
                                    return (
                                        <tr key={index}>
                                            <td className="po-item-name">{capitalizeFirstLetter(item?.inventory?.item_name) || "N/A"}</td>
                                            <td>{item?.inventory?.uom?.uom ? `${capitalizeFirstLetter(item?.inventory?.uom?.uom)} (${item?.inventory?.uom?.uom_code})` : "N/A"}</td>
                                            <td className="text-end">{showPrice(item?.price)} SAR</td>
                                            <td className="text-end">{formatToTwoDecimals(item?.ordered_quantity)}</td>
                                            <td>
                                                <div className="po-qty-input">
                                                    <input
                                                        className={`form-control text-end ${isInvalid ? 'is-invalid' : ''}`}
                                                        type="number"
                                                        min="0"
                                                        value={quantities[item.inventory_id]}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === '' || /^(\d+|\d*\.\d{0,2})$/.test(value)) {
                                                                handleQuantityChange(item.inventory_id, value);
                                                            }
                                                        }}
                                                        required
                                                    />
                                                    <span className="po-qty-unit">{item?.inventory?.uom?.uom_code || ''}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr className="po-total-row">
                                    <td colSpan="4" className="text-end">Total</td>
                                    <td className="text-end">{showPrice(receivedTotal)} SAR</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="invoice_number">
                                    Invoice Number <span className="requirestar">*</span>
                                </label>
                                <input
                                    name="invoice_number"
                                    id="invoice_number"
                                    type="text"
                                    placeholder="Enter invoice number"
                                    className={`form-control ${invoiceError ? 'is-invalid' : ''}`}
                                    required
                                    pattern="^[1-9][0-9]*$"
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        const isValid = /^[1-9][0-9]*$/.test(value);
                                        if (!isValid) {
                                            e.target.setCustomValidity('Invoice number must be a positive integer and cannot contain decimals or be negative.');
                                        }
                                        else if (value.length > 15) {
                                            e.target.setCustomValidity('Invoice number cannot exceed 15 digits.');
                                        } else {
                                            e.target.setCustomValidity('');
                                        }
                                        validateForm();
                                    }}
                                    onInvalid={(e) => {
                                        if (!e.target.value) {
                                            e.target.setCustomValidity('Please enter a valid invoice number.');
                                        }
                                    }}
                                />
                                <span className="po-field-hint">{invoiceError ? <span className="text-danger">Invoice number should be a positive whole number of up to 15 digits.</span> : 'Positive whole number, up to 15 digits.'}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="logo">
                                    Upload Invoice <span className="requirestar">*</span>
                                </label>
                                <div className="po-upload">
                                    <label htmlFor="logo" className="btn btn-outline-primary btn-sm po-upload-btn mb-0">
                                        <i className="ti ti-upload"></i>
                                        {previewImage || pdfFileName ? 'Change file' : 'Choose file'}
                                    </label>
                                    <input
                                        id="logo"
                                        name="logo"
                                        accept="image/*, application/pdf"
                                        type="file"
                                        className="d-none"
                                        onChange={handleFileUpload}
                                    />
                                    {previewImage ? (
                                        <div className="po-upload-preview">
                                            <img alt="Invoice preview" src={previewImage} />
                                            <button type="button" className="po-upload-clear" onClick={clearInvoiceFile} title="Remove file">
                                                <i className="ti ti-x"></i>
                                            </button>
                                        </div>
                                    ) : (previewFileType === 'pdf' && pdfFileName) ? (
                                        <div className="po-upload-file">
                                            <i className="ti ti-file-text"></i>
                                            <span>{TrimText(pdfFileName, 24)}</span>
                                            <button type="button" className="po-upload-clear" onClick={clearInvoiceFile} title="Remove file">
                                                <i className="ti ti-x"></i>
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                                <span className="po-field-hint">Image or PDF, up to 10 MB.</span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="po-modal-footer">
                    <span className="po-modal-hint">{!isFormValid ? 'Enter an invoice number and upload the invoice to confirm.' : ''}</span>
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-secondary" onClick={handleCloseModal}>
                            Close
                        </button>
                        <Button variant="primary" onClick={handleConfirm} disabled={!isFormValid}>
                            Confirm
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default OrderView;
